module.exports = __webpack_public_path__ + "img/title-bg.394a1184.png";